<app-navbar></app-navbar>

<div class="container-fluid course-page">
  <div class="row">
    <nav class="col-md-3 col-lg-2 d-md-block sidebar course-sidebar">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" routerLink="/electric-cars">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Electric Cars</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/design-and-manufacturing">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Design and Manufacturing</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" routerLink="/auto-electrical">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Auto Electrical of an Electric Scooter</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/iot">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Internet of Things</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/charger-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Charger Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/solar-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Solar Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/welding">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Welding</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <main role="main" class="col-md-9 col-lg-10 ms-sm-auto px-3 px-md-4 py-4 course-content">
      <section class="course-header">
        <p class="course-tag">FEA Course</p>
        <h1>FEA - Auto Electricals of an Electric Scooter</h1>
        <p class="course-subtitle">Learn through guided lessons and complete the module resources and progress checkpoints.</p>
      </section>

      <section class="lesson-grid">
        <article class="lesson-card">
          <h4><span>01</span> Auto Electricals of an Electric Scooter</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FAuto-Electricals-of-an-Electric-Scooter-Gifty-Afun%2FGifty%20(Auto%20Electical%20of%20An%20Electric%20Scooter).mp4?alt=media&token=1dbca1a4-acbf-4a48-9693-095ac09cac5a" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>02</span> Battery Management System</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FAuto-Electricals-of-an-Electric-Scooter-Gifty-Afun%2FGifty%20(%20Battery%20Management%20System).mp4?alt=media&token=5b647773-4d6d-4a09-8f5c-c28641b46f20" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>03</span> Electric Speed Controller</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FAuto-Electricals-of-an-Electric-Scooter-Gifty-Afun%2FGifty%20(Electronic%20Speed%20Controller).mp4?alt=media&token=6e0bafc6-b0f0-4d0a-99b0-438630a63b93" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>04</span> Brushless DC Motor</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FAuto-Electricals-of-an-Electric-Scooter-Gifty-Afun%2FGifty%20(Brushless%20DC%20Motor).mp4?alt=media&token=ff970d87-c6cc-4f48-9ef2-50ad4c3ad672" type="video/mp4">
          </video>
        </article>

      </section>

      <section class="course-actions">
        <a class="btn solarorange" href="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FAuto-Electricals-of-an-Electric-Scooter-Gifty-Afun%2FAUTO%20ELECTRICALS%20OF%20AN%20E-SCOOTER%20(1).pptx?alt=media&token=75c17ea4-7d10-4d6d-bf43-181a0a2bd98f" target="_blank" rel="noopener noreferrer">
          Download Course Material
        </a>

        <a class="btn solarblue" href="https://forms.gle/TmWv7uYHoxA9SxLn8" target="_blank" rel="noopener noreferrer">
          Take Assessment
        </a>

        <button type="button" class="btn solarorange complete-btn" (click)="completed()">
          Mark Completed
        </button>
      </section>
    </main>
  </div>
</div>
